import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.blog-detail-page': {
		'.blog-detail-page__masthead-title': {
			textTransform: 'capitalize',
		},
		'.blog-detail-page__relation-list': {
			display: 'inline',
            '.blog-detail-page__relation-list__link': {
                color: getColor('ivory', 600),
                fontSize: remCalc(16),
                fontFamily: 'var(--font-brandon-grotesque)',
                fontWeight: 420,
                textDecoration: 'none !important',
                textTransform: 'uppercase',
                lineHeight: remCalc(20),
                letterSpacing: remCalc(2),
                wordWrap: 'break-word',
				borderBottom: `1px solid ${getColor('ivory', 600)}`,
				transition: 'all var(--transition-duration) ease-in',
				'&:hover,&:focus-visible': {
					color: getColor('ivory', 700),
					borderBottomColor: getColor('ivory', 700),
				}
            }
		},
		'.blog-detail-page__body': {
			color: getColor('ivory', 700),
			fontFamily: 'var(--font-avenir-next)',
			fontSize: remCalc(20),
			fontWeight: 500,
			lineHeight: 1.45,
			letterSpacing: remCalc(0.4),
			paddingTop: remCalc(40),
			paddingBottom: remCalc(40),
			[theme.breakpoints.up('sm')]: {
				paddingTop: remCalc(72),
				paddingBottom: remCalc(72),
			},
		},
		'.blog-detail-page__footer-attribs': {
			paddingBottom: remCalc(36),
			[theme.breakpoints.up('sm')]: {
				paddingBottom: remCalc(72),
			},

			'.pageAttribs__items': {
				'.pageAttribs__item': {
					'.pageAttribs__item__icon': {
						display: 'none',
					},
				},
			},

			'.blog-detail-page__footer-attribs__nav-link': {
				display: 'inline-flex',
				alignItems: 'center',
				gap: remCalc(12),
				fontFamily: 'var(--font-brandon-grotesque)',
				fontSize: remCalc(16),
				fontWeight: 500,
				lineHeight: remCalc(20),
				letterSpacing: remCalc(2),
				textTransform: 'uppercase',
				'&.blog-detail-page__footer-attribs__nav-link--disabled': {
					opacity: 0.55,
					cursor: 'default',
					pointerEvents: 'none',
				},
			},
			'.blog-detail-page__footer-attribs__arrow': {
				display: 'inline-block',
				width: remCalc(13),
				height: remCalc(13),
			},
			'.blog-detail-page__footer-attribs__share': {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				gap: remCalc(12),
			},
			'.blog-detail-page__footer-attribs__share-label': {
				fontFamily: 'var(--font-brandon-grotesque)',
				fontSize: remCalc(16),
				fontWeight: 500,
				lineHeight: remCalc(20),
				letterSpacing: remCalc(2),
				textTransform: 'uppercase',
				color: getColor('ivory', 600),
			},
			'.blog-detail-page__footer-attribs__share-actions': {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				gap: remCalc(18),
			},
			'.blog-detail-page__footer-attribs__share-button': {
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: 0,
				border: 'none',
				background: 'transparent',
				color: getColor('ivory', 600),
				lineHeight: 0,
				cursor: 'pointer',
				transition: 'color var(--transition-duration-fast)',
				'& svg': {
					width: remCalc(18),
					height: remCalc(18),
				},
				'&:focus-visible': {
					outline: `1px solid ${getColor('ivory', 500)}`,
					outlineOffset: remCalc(3),
					color: getColor('ivory', 400),
				},
			},

			[theme.breakpoints.up('md')]: {
				'.pageAttribs__items': {
					marginTop: remCalc(24),
					padding: `${remCalc(40)} 0`,
					gap: remCalc(28),
					'.pageAttribs__item': {
						'&.pageAttribs__item--first': {
							justifyContent: 'flex-start',
						},
						'&.pageAttribs__item--last': {
							justifyContent: 'flex-end',
						},
					},
					'.pageAttribs__divide': {
						flexShrink: 0,
					},
				},
				'.blog-detail-page__footer-attribs__share': {
					flexDirection: 'row',
					gap: remCalc(36),
				},
				'.blog-detail-page__footer-attribs__share-actions': {
					gap: remCalc(20),
				},
			},
		},
	},
};

export default styles;
